import { IBaseFieldOptions } from '../../../interface/custom-lists/base-field-options.interface';
import { observable } from 'mobx';
import { persist } from 'mobx-persist';

export class BaseFieldOptionsModel implements IBaseFieldOptions {
  @persist @observable locked: boolean;
}